import { Products } from "../../components";

export const Product = () => {
  return (
    <div className="container__pages">
      <h2>Lista de productos</h2>
      <div className="container_form">
        <Products />
      </div>
    </div>
  );
};
